import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomebannermenuComponent } from './homebannermenu.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


const routes: Routes = [
  {
    path: '',
    component: HomebannermenuComponent,
    data: {
      title: "Homebannermenu",
      breadcrumb: "Homebannermenu"
    }
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [],
  exports: [RouterModule]
})
export class HomebannermenuRoutingModule { }